export const formatStringPhone = (phone: string): string =>
  `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;

export const toTitleCase = (str: string): string => {
  if (!str) {
    return "";
  }
  const knownAcronynms = {
    cvs: true,
    "": true,
    llc: true,
  };
  return str
    .toLowerCase()
    .split(" ")
    .map(word =>
      knownAcronynms[word]
        ? word.toUpperCase()
        : word.replace(word[0], word[0].toUpperCase())
    )
    .join(" ");
};
